import React from 'react'
import { CustomDataTableHeader, Loading } from '../../../../components'
import { Column } from 'primereact/column'
import { ColumnGroup } from 'primereact/columngroup'
import { Row } from 'primereact/row'
import { DataTable } from 'primereact/datatable'
import { getBipsFaltantes } from '../../../../services/api/https/picking/picking.http'
import TabBipsFaltantesModal from './TabBipsFaltantesModal'
import './TabHistorico.css'

const TabBipsFaltantes = ({ pickingId }) => {
  const [items, setItems] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(true)
  const [globalFilter, setGlobalFilter] = React.useState('')
  const [selectedItem, setSelectedItem] = React.useState(null)

  React.useEffect(() => {
    _getBipsFaltantes()
  }, [])

  const _getBipsFaltantes = async () => {
    try {
      const response = await getBipsFaltantes(pickingId)
      setItems(
        (response || []).map(item => ({
          ...item,
          produto: [item.product_code, item.product_name].filter(Boolean).join(' - '),
        })),
      )
    } catch (error) {
      console.error('Erro ao buscar BIPs faltantes:', error)
      setItems([])
    } finally {
      setIsLoading(false)
    }
  }

  if (isLoading) {
    return (
      <div className="text-center">
        <Loading />
      </div>
    )
  }

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column
          header={'Produto'}
          field={'produto'}
          sortable
          rowSpan={2}
          className="column-responsive column-important"
        />
        <Column header={'Qte. Total'} colSpan={2} style={{ textAlign: 'center' }} />
        <Column header={'Qte. Separada'} colSpan={2} style={{ textAlign: 'center' }} />
        <Column header={'Qte. Dif'} colSpan={2} style={{ textAlign: 'center' }} />
        <Column
          header={'Área'}
          field={'area_name'}
          sortable
          rowSpan={2}
          className="column-responsive"
          style={{ width: '180px' }}
        />
      </Row>
      <Row>
        <Column
          header={'Vol'}
          field={'vol_total'}
          sortable
          className="column-number"
          style={{ width: '90px' }}
        />
        <Column
          header={'Uni'}
          field={'uni_total'}
          sortable
          className="column-number"
          style={{ width: '90px' }}
        />
        <Column
          header={'Vol'}
          field={'vol_separada'}
          sortable
          className="column-number"
          style={{ width: '90px' }}
        />
        <Column
          header={'Uni'}
          field={'uni_separada'}
          sortable
          className="column-number"
          style={{ width: '90px' }}
        />
        <Column
          header={'Vol'}
          field={'vol_dif'}
          sortable
          className="column-number"
          style={{ width: '90px' }}
        />
        <Column
          header={'Uni'}
          field={'uni_dif'}
          sortable
          className="column-number"
          style={{ width: '90px' }}
        />
      </Row>
    </ColumnGroup>
  )

  return (
    <>
      <div className="p-grid p-col-12">
        <div className="p-col-12 p-datatable-responsive">
          <DataTable
            value={items}
            emptyMessage={'Não existem produtos com BIPs faltantes'}
            header={
              <div style={{ width: '100%', height: 50 }}>
                <CustomDataTableHeader onChange={setGlobalFilter} />
              </div>
            }
            headerColumnGroup={headerGroup}
            globalFilter={globalFilter}
            rows={15}
            paginator={true}
            selectionMode={'single'}
            onSelectionChange={e => setSelectedItem(e.value)}
            responsive={true}
          >
            <Column field={'produto'} className="column-responsive column-important" />
            <Column field={'vol_total'} className="column-number" style={{ width: '90px' }} />
            <Column field={'uni_total'} className="column-number" style={{ width: '90px' }} />
            <Column field={'vol_separada'} className="column-number" style={{ width: '90px' }} />
            <Column field={'uni_separada'} className="column-number" style={{ width: '90px' }} />
            <Column field={'vol_dif'} className="column-number" style={{ width: '90px' }} />
            <Column field={'uni_dif'} className="column-number" style={{ width: '90px' }} />
            <Column field={'area_name'} className="column-responsive" style={{ width: '180px' }} />
          </DataTable>
        </div>
      </div>
      <TabBipsFaltantesModal
        onClose={() => setSelectedItem(null)}
        visible={selectedItem !== null}
        item={selectedItem}
        pickingId={pickingId}
      />
    </>
  )
}

export default TabBipsFaltantes
